export function parseBibtex(text) {
  const entries = [];
  const blocks = text.match(/@\w+\{[\s\S]*?\n\}/g) || [];

  for (const block of blocks) {
    const typeMatch = block.match(/@(\w+)\{([^,]+),/);
    if (!typeMatch) continue;

    const entryType = typeMatch[1].toLowerCase();
    const citationKey = typeMatch[2].trim();
    const fields = {};

    const fieldRegex = /(\w+)\s*=\s*\{([^}]*)\}/g;
    let match;
    while ((match = fieldRegex.exec(block)) !== null) {
      fields[match[1].toLowerCase()] = match[2].trim();
    }

    const doi = fields.doi?.replace("https://doi.org/", "").trim();
    entries.push({
      id: citationKey,
      type: entryType,
      title: fields.title || "Untitled",
      authors: fields.author || "",
      journal: fields.journal || fields.booktitle || "",
      year: fields.year ? parseInt(fields.year, 10) : 0,
      doi,
      url: fields.url || fields.ee || (doi ? `https://doi.org/${doi}` : null),
    });
  }

  return entries.sort((a, b) => b.year - a.year);
}
